angular.module 'zc.commonApi'

.factory "installationChecker", ($q, Facade) ->
  service =
    checkTrackingCode: (params) ->
      Facade.request "/apikeys/#{params.apikey}/setup/check_tracking_code", {
        params: params
        cache: false
      }
      .then (res) ->
        res.data

    getLatestConversions: (params) ->
      Facade.request "/apikeys/#{params.apikey}/conversions/latest", {
        params: params
        cache: false
      }
      .then (res) ->
        res.data.conversions

    checkPageTypes: (params) ->
      Facade.request "/apikeys/#{params.apikey}/installation/check_page_types", {
        params: params
        cache: false
      }
      .then (res) ->
        res.data

    checkConversionTag: (params) ->
      Facade.request "/apikeys/#{params.apikey}/installation/check_conversion_tag", {
        params: params
        cache: false
      }
      .then (res) ->
        res.data

    checkDomains: (params) ->
      Facade.request "/apikeys/#{params.apikey}/installation/check_domains", {
        params: params
        cache: false
      }
      .then (res) ->
        res.data

    checkSessionCountEvaluator: (params) ->
      Facade.request "/apikeys/#{params.apikey}/installation/check_session_count_evaluator", {
        params: params
        cache: false
      }
      .then (res) ->
        res.data

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/installation_checker.js.coffee